<template>
  <provider-form
    :id="0"
    @submit="addProvider"
    @close="$emit('close')"
  />
</template>

<script>
import ProviderForm from '../Form.vue'
import redirectError from '@/services/redirectError'

export default {
  name: 'CrateProvider',
  components: { ProviderForm },
  methods: {
    addProvider(provider) {
      const query = {
        provider: {
          name: provider.name,
          webhookUrl: provider.webhookUrl,
          type: provider.type,
        },
      }
      this.$store
        .dispatch('providers/addProvider', query)
        .then(() => {
          this.successToast('Provider was added!')
          this.$emit('onRefresh')
        })
        .catch(error => {
          redirectError(error)
          this.errorToast(
            error.response?.data?.errors[0]
              || 'Something went wrong while creating provider!',
          )
        })
    },
  },
}
</script>
